import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Overlay } from '@loomstateorg/shared-frontend';
export const Layout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleStart = (_url: string) => setIsLoading(true);
    const handleComplete = (_url: string) => setIsLoading(false);

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
    };
  }, [router.events]);

  return (
    <>
      {isLoading && <Overlay showSpinner={false} />}
      {children}
    </>
  );
};

export default Layout;
